import { take } from 'rxjs/operators';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SiteContextService } from '@core/services/site-context.service';
import { ChildrenLinksConfiguration } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { PageViewModel, SearchResultCmsPageViewModel } from '@models/api.models';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { ChildrenLinksService } from './children-links.service';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { FormatStringPipe } from '@shared/format-string/format-string.pipe';
import { PageLinksComponent } from '../../page-links/page-links/page-links.component';
import { LoadingDotsComponent } from '@shared/loading-dots/loading-dots.component';
import { NgIf } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-children-links',
    templateUrl: './children-links.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ChildrenLinksService],
    imports: [NgIf, LoadingDotsComponent, PageLinksComponent, FormatStringPipe, TranslateSafePipe]
})
export class ChildrenLinksComponent implements OnInit {
    public static readonly ref: string = 'childrenLinks';

    public childrenLinks: SearchResultCmsPageViewModel[] | undefined;

    @Input()
    public data: ChildrenLinksConfiguration & PageViewModel;

    constructor(
        private childrenLinksService: ChildrenLinksService,
        private changeDetector: ChangeDetectorRef,
        private siteContextService: SiteContextService
    ) {}

    ngOnInit(): void {
        this.siteContextService.context$.pipe(untilDestroyed(this), take(1)).subscribe(context => {
            const { pageId } = context;
            if (!pageId) {
                return;
            }
            this.childrenLinksService
                .getContentChildren(pageId)
                .pipe(untilDestroyed(this), take(1))
                .subscribe(response => {
                    this.childrenLinks = response;
                    this.changeDetector.markForCheck();
                });
        });
    }
}
